import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { MAT_CARD_CONFIG } from '@angular/material/card';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { AuthHttpInterceptor, provideAuth0 } from '@auth0/auth0-angular';
import { Idle, IdleExpiry } from '@ng-idle/core';
import {
  CookieExpiry,
  IDLE_CONFIG,
  IdleConfig,
  SHELL_HOME_CONFIG_RI,
  ShellHomeConfigRi,
} from '@r1-development/rps-shared-ui';
import { environment } from '../environments/environment';
import { AppInitializerService } from './admin/services/initializers/app-initializer.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    // App Initializer
    provideAppInitializer(() => inject(AppInitializerService).initializeApp()),

    // HTTP and Interceptors
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    // Angular Features
    provideAnimations(),

    // Angular Material Configuration
    provideNativeDateAdapter(),
    { provide: MAT_CARD_CONFIG, useValue: { appearance: 'outlined' } },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { hideSingleSelectionIndicator: true },
    },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 500 } },

    // Auth0 Configuration
    provideAuth0({
      domain: environment.auth0Config.domain,
      clientId: environment.auth0Config.clientId,
      authorizationParams: {
        // eslint-disable-next-line camelcase -- Auth0 API requires snake_case
        redirect_uri: environment.auth0Config.redirectUri,
        audience: environment.auth0Config.audience,
      },
      httpInterceptor: {
        allowedList: environment.auth0Config.httpInterceptor.allowedList,
      },
    }),

    // Idle Timeout Configuration
    {
      provide: IDLE_CONFIG,
      useValue: {
        secondsBeforeModal: 1800,
        secondsBeforeTimeout: 90,
      } as IdleConfig,
    },
    {
      provide: SHELL_HOME_CONFIG_RI,
      useValue: {
        adminUrl: environment.uiUrl.adminUrl,
        isLocal: environment.isLocal,
        logoutWhenIdle: true,
        riUserManagementApiUrl: environment.api.riUserManagementBaseURL,
        sidebarMenuGroup: environment.applicationGroupName,
        usePendo: environment.isPendo,
      } as ShellHomeConfigRi,
    },
    { provide: IdleExpiry, useExisting: CookieExpiry },
    CookieExpiry,
    Idle,
  ],
};
